import { observer } from 'mobx-react';
import { Dialog } from 'primereact/dialog';
import { FileUpload, FileUploadHeaderTemplateOptions, ItemTemplateOptions } from 'primereact/fileupload';
import { Input, InputType } from './inputs/Inputs';
import { X, File } from 'lucide-react';
import { useRef } from 'react';
import { Appl } from '../Appl';
import { Button } from './Index';
import { SpinnerIcon } from './dialogs/SpinnerIcon';

export interface DocumentsModel {
  docId?: number;
  docTypeId: number;
  docType?: string;
  docFileSize?: string;
  docFilename?: string;
  isNew?: boolean;
  file?: any;
}

export const UploadUtility: React.FC<{
  onHide: () => void;
  onOk: () => void;
  visible: boolean;
  isbusy: boolean;
  dialogHeader: string;
  emptyTemplateInfoText?: string
  activeDocument: DocumentsModel;
  maxFileSize: number;
  chooseLabel: string;
  allowedFileExtensions: string;
  docTypeId: number;
  readonlyDocNameInput: boolean;
  uploadComplete: boolean;
}> = observer((props) => {


  let activeDocument: DocumentsModel = props.activeDocument;
  const uploadRef = useRef<FileUpload>(null);

  const itemTemplate = (inFile: object, props: ItemTemplateOptions) => {
    const file = inFile as File;
    activeDocument.docFilename = file.name;
    activeDocument.file = file;
    activeDocument.docFileSize = props.formatSize;
    activeDocument.isNew = true;
    return (
      <div className="w-full flex justify-between items-center">
        <div className='flex items-center'>
          <File className='w-12 h-12 me-2' />
          <span className="font-medium">{activeDocument.docFilename}<br />{activeDocument.docFileSize}</span>
        </div>
      </div >
    );
  };

  const headerTemplate = (options: FileUploadHeaderTemplateOptions) => {
    return (
      <div className={`${options.className} mb-2`}>
        {options.chooseButton}
      </div>
    );
  };

  const emptyTemplate = () => {
    return (
      <div className='border-dashed rounded-lg border-[#B3B3B3] p-6'>
        <div className="text-center text-gray-800 font-medium mt-2 mb-2">Choose a file or drag & drop it here</div>
        <div className="text-center text-gray-400 mt-2 mb-2">{props.emptyTemplateInfoText}</div>
        <div className="text-center text-gray-400 mt-2 mb-2">
          <Button severity='secondary' rounded title='Browse Files' onClick={() => { uploadRef.current?.getInput().click() }} />
        </div>
      </div>
    );
  };
  return (
    <>
      <Dialog visible={props.visible} modal
        draggable={false}
        onHide={() => props.onHide()}
        style={{ width: '800px' }}
        header={props.dialogHeader}
      >
        <hr />
        {props.isbusy && (
          <div className="bg-white/20 fixed top-0 left-0 w-full h-full z-50 flex items-center justify-center">
            <SpinnerIcon className="w-6 h-6 text-black" size="4" />
          </div>
        )}
        <div className='p-6'>
          <div>
            <Input
              id="docType"
              value={props.activeDocument.docType}
              inputType={InputType.Text}
              onChange={(e) => { props.activeDocument.docType = e.target.value; }}
              label="Document:"
              required={true}
              style={{ width: '400px', marginBottom: '10px' }}
              readOnly={props.readonlyDocNameInput}
            />
          </div>
          <FileUpload
            ref={uploadRef}
            mode="advanced"
            name={`files${props.activeDocument?.docTypeId}`}
            id={`files${props.activeDocument?.docTypeId}`}
            accept={props.allowedFileExtensions}
            maxFileSize={props.maxFileSize}
            chooseLabel={props.chooseLabel}
            headerTemplate={headerTemplate}
            headerClassName='hidden'
            progressBarTemplate={<></>}
            itemTemplate={itemTemplate}
            emptyTemplate={emptyTemplate}
            className='max-h-60 overflow-y-auto' 
          />
          <div className='justify-center flex gap-x-4'>
            {props.uploadComplete &&
              <Button className="mt-4" rounded label="Done" onClick={() => props.onHide()} />
            }
            {!props.uploadComplete &&
              <Button className="mt-4" rounded label="Upload Document" onClick={() => {
                if (props.activeDocument.docType === '') {
                  Appl.MessageBox.show('Document Name is required.', 'Outstanding Documents', '', 'Okay', true)
                } else {
                  props.onOk();
                }
              }
              } />
            }
            <Button severity='secondary' rounded className="mt-4 me-2" label="Cancel" onClick={() => props.onHide()} />
          </div>
        </div>
      </Dialog>
    </>
  );
});
